import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Navigation,  Keyboard, A11y  } from "swiper";
import { Link } from "react-router-dom";
import { Img } from "../../components/shared/img";
import { NavigationButtonsBooks } from "./navigation-buttons";
import { ASSETS_URL } from "../../components/Store";
import normalizeString from "../../js/utilities/normalizeString";
import { useLanguage } from "../../hooks/use-language";
import { useTranslationsById } from "../../hooks/use-translations-by-id";

/**
 * Componente swiper de editoriales en responsive
 * @returns {JSX.Element} Componente SwiperPublishersResponsive
 */
export const SwiperPublishersResponsive = ({ editoriales }) => {
    const prevButtonRef = useRef(null);
    const nextButtonRef = useRef(null);

    const lang = useLanguage();
    const texts = useTranslationsById({ mainSectionName: "libros", language: lang });

    const updateNavigation = (swiper) => {
        swiper.params.navigation.prevEl = prevButtonRef?.current
        swiper.params.navigation.nextEl = nextButtonRef?.current
        swiper.navigation.destroy()
        swiper.navigation.init()
        swiper.navigation.update()
    }

    /**
    * Esta función transforma el nombre de la editorial en un parametro buscable 
    * @param {string} caracter //string: caracter que debe ser reemplazado por nuevoCaracter
    * @param {string} nuevoCaracter //string: nuevo caracter
    * @param {string} texto //string: nombre de la editorial
    * @returns 
    */
    const newUrlEditorial = (caracter, nuevoCaracter, texto) => {
        var buscarCaracter = texto.search(caracter);
        var newUrl;
        if (buscarCaracter === -1) {
            newUrl = normalizeString(texto).replace(caracter, nuevoCaracter);
            return newUrl;
        } else {
            return normalizeString(texto);
        }
    };

    return (
        <>
            <Swiper
                className="px-5"
                style={{ overflowX: "hidden" }}
                slidesPerView={"auto"}
                freeMode={true}
                direction="horizontal"
                mousewheel={{
                    forceToAxis: false,
                }}
                navigation={{
                    nextEl: nextButtonRef?.current,
                    prevEl: prevButtonRef?.current,
                }}
                onSwiper={(swiper) => {
                    updateNavigation(swiper);
                }}
                keyboard={{ enabled: true }}
                modules={[Navigation, Mousewheel, FreeMode, Keyboard, A11y]}
                a11y={{
                    containerMessage: texts.getText({ id: "publishers.containerMessage", defaultText: "todas las editoriales" }),
                    itemRoleDescriptionMessage: texts.getText({ id: "publishers.itemRoleDescriptionMessage", defaultText: "agrupacion de editoriales" }),
                    paginationBulletMessage: texts.getText({ id: "publishers.paginationBulletMessage", defaultText: "ir al siguiente grupo" })
                }}
                onSlideChange={(swiper) => {
                    const status = document.getElementById("carousel-publishers-status");
                    if (status) {
                        status.textContent = `${texts.getText({ id: "publishers.onSlideChange", defaultText: "Grupo de editoriales número" })}  ${swiper.realIndex + 1}`;
                    }
                }}
            >
                {editoriales.map((publisher, i) => {
                    return (
                        <SwiperSlide
                            key={i}
                            className="d-flex justify-content-center align-items-center mx-2 p-0"
                            style={{
                                minWidth: 150,
                                maxWidth: 150,
                                height: "auto",
                                pointerEvents: "none",
                                background: "#fff"
                            }}
                        >
                            <Link
                                to={`/editorial/${newUrlEditorial("---", "-", publisher?.nombreEditorial || '')}`}
                                style={{
                                    height: 136,
                                    width: 120,
                                    pointerEvents: "none",
                                    backgroundImage: `url(${ASSETS_URL}${publisher?.logo})`,
                                    backgroundSize: 'contain',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    filter: "grayscale(100%)",
                                }}>
                                <p className="sr-only">{texts?.getText({ id: "publishers.imgAlt", defaultText: "Logo de la editorial" })} - {publisher?.nombreEditorial}</p>
                            </Link>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <div aria-live="polite" className="sr-only" id="carousel-publishers-status"></div>
            <div className="my-4">
                <NavigationButtonsBooks nextButtonRef={nextButtonRef} prevButtonRef={prevButtonRef} responsiveButtons={true} />
            </div>
        </>
    )
}